import moment from "moment";
import { extractCountryCode } from "@/utils/validations/phoneNumberValidations";

// ? takes a string as param, if it is a valid email, returns true, else returns false
export const validateEmail = (testEmail: string) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(testEmail.toLowerCase());
};

// ? takes a string as param, if it is a valid name, returns true, else returns false
// ? allows only alphabets, space and dot(.)
export const validateUserName = (name: string) => {
  const re = /^[a-zA-Z \. ]+$/;
  return name.match(re);
};

// ? takes a string as @param, if it is not a number and returns true if it is a valid email
// ? if it is a number, returns true if the is 10 digits long, else returns false
export const validateEmailOrMobile = (testString: string) => {
  if ((isNaN(+testString) && validateEmail(testString)) || (!isNaN(+testString) && testString.length === 10))
    return true;
  return false;
};
export const validateMobile = (testString: string, checkDataTypeOnly?: any) => {
  if (checkDataTypeOnly) {
    if (!isNaN(+testString) && testString.length > 0) {
      return true;
    }
    return false;
  }
  if (!isNaN(+testString) && testString.length === 10) {
    return true;
  }
  return false;
};
export const validateISDNumber = (mobileNumber: string) => {
  // eg 919811047864
  const countryCode = mobileNumber.slice(0, 2); // 91
  const number = mobileNumber.replace(/^91/, ""); // 9811047864

  if (countryCode === "91" && number.length === 10) {
    return true;
  }
  if (number.length >= 7 && number.length <= 15 && countryCode !== "91") {
    return true;
  }
  return false;
};

export const insertValuesIntoString = (string: string, values: any[]) => {
  let finalString = string;

  for (const value of values) {
    finalString = finalString?.replace("{}", value);
  }

  return finalString;
};

export const CheckIfUpcomingBooking = (flightDate) => {
  const currentDate = moment(new Date()).format("YYYY-MM-DD HH:MM");
  const expiryDate = moment(flightDate).format("YYYY-MM-DD HH:MM");

  if (moment(expiryDate).isAfter(currentDate)) {
    return true;
  }
  return false;
};

export const formatPhoneNumber = (value, countryCode) => {
  const phoneNum = value?.slice(countryCode.length);
  const output = `${countryCode}-${phoneNum}`;

  return output;
};

export const getCountryEligiblity = (formattedPhoneNumber) => {
  const countryCode = extractCountryCode(formattedPhoneNumber);
  const isIndianNumber = !!(countryCode === "91" || countryCode === "+91");

  return isIndianNumber;
};

export const prependCountryCode = (mobileNumber: string) => {
  if (mobileNumber?.length <= 10) {
    return `91-${mobileNumber}`;
  }
  return mobileNumber;
};
